import { Message, SearchNormal } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { timeAgo } from "../../../utils/calculateAge";
import { Link, useLoaderData, useRevalidator } from "react-router-dom";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";
import { toast } from "react-toastify";

export const notificationLoader = async () => {
  const token = getToken();
  const res = await instance.get("/doctor/notifications", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const NotificationsPage = () => {
  const notifications = useLoaderData();

  const [filteredList, setFilteredList] = useState(notifications);
  const [searchQuery, setSearchQuery] = useState("");
  const [isActive, setIsActive] = useState("all");
  const [marked, setMarked] = useState(notifications.filter(notification => notification.status !== 'new').map(_ => _.id));
  const revalidator = useRevalidator()

  const handleSearch = (e) => {
    e.preventDefault();

    const query = searchQuery.toLowerCase();
    setFilteredList(() => {
      return notifications.filter((notification) => {
        return (
          notification.msg.toLowerCase().includes(query) ||
          notification.orderId.toLowerCase().includes(query)
        );
      });
    });
  };

  const filterBy = (def, notifications) => {
    if (def === "read") {
      setIsActive("read");
      setFilteredList(() =>
        notifications.filter((notification) => notification.status === "read")
      );
    } else if (def === 'unread') {
      setIsActive("unread");
      setFilteredList(() =>
        notifications.filter((notification) => notification.status === "new")
      );
    } else {
      setIsActive("all");
      setFilteredList(() =>
        notifications
      );
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      const token = getToken();
      await instance.put("/doctor/notifications/edit", { notifId: id }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      toast.success('Marked as read');
      revalidator.revalidate();
      setMarked([...marked, id]);
    } catch (error) {
      toast.error("An error occurred");
    }
  };


  useEffect(() => {
    filterBy(isActive, notifications);
  }, [notifications, isActive]);

  return (
    <div className="bg-[#fafafa] max-w-[100%] w-full px-7 py-5">
      <div className="flex justify-between items-center">
        <div className="text-2xl font-bold">
          Notifications ({notifications.length})
        </div>
      </div>

      <div className="border bg-white rounded-md mt-4">
        <div className="flex flex-col 2xl:flex-row gap-y-3 gap-x-2 justify-between p-2 2xl:items-center mb-5 lg:mb-0">
          <form className="relative mb-3 lg:mb-0" onSubmit={handleSearch}>
            <input
              className="outline-none h-[40px] w-full 2xl:w-[300px] border rounded-md p-2 placeholder:font-normal placeholder:text-[14px] text-sm"
              placeholder="Search doctor by msg/id(1,2,3)"
              name="query"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="absolute h-[38px] rounded-md top-1/2 -translate-y-1/2 right-[1px] w-[30px] flex items-center justify-center bg-white cursor-pointer hover:text-primary duration-300"
              type="submit"
            >
              <SearchNormal size={15} />
            </button>
          </form>

          <div className="flex gap-2 items-center max-w-[300px] mx-auto lg:max-w-full lg:mx-0">
            <button
              className={`${
                isActive === "all"
                  ? "bg-primary font-semibold border-primary text-white"
                  : "bg-white"
              } w-[150px] text-sm h-9 hover:border-primary duration-300 cursor-pointer border flex justify-center items-center rounded-md disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-[#eee]`}
              onClick={() => filterBy("all", notifications)}
            >
              All
            </button>
            <button
              className={`${
                isActive === "read"
                  ? "bg-primary font-semibold border-primary text-white"
                  : "bg-white"
              } w-[150px] text-sm h-9 hover:border-primary duration-300 cursor-pointer border flex justify-center items-center rounded-md disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-[#eee]`}
              onClick={() => filterBy("read", notifications)}
            >
              Read
            </button>
            <button
              className={`${
                isActive === "unread"
                  ? "bg-primary font-semibold border-primary text-white"
                  : "bg-white"
              } w-[150px] text-sm h-9 hover:border-primary duration-300 cursor-pointer border flex justify-center items-center rounded-md disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-[#eee]`}
              onClick={() => filterBy("unread", notifications)}
            >
              Unread
            </button>
          </div>
        </div>

        <div className="max-h-[73vh] overflow-y-scroll scrollbar-hide">
          {filteredList.map((notification, index) => (
            <div
              key={index}
              className={`border-t grid grid-cols-[auto_15%_15%_15%] gap-x-3 px-2 py-4 $font-normal bg-[#fff]`}
            >
              {/* <Message size="20" color="#00B0AD" /> */}
              <p key={index} className={`text-sm`}>
                {notification.msg}
              </p>
              {notification.order_id ? (
                <Link
                  className="text-sm underline text-primary"
                  to={`/dashboard/orders/${notification.order_id}`}
                >
                  #{notification.order_id}
                </Link>
              ) : (
                <span> </span>
              )}
              <span className="text-xs text-gray-700">
                {timeAgo(notification.created_at)}
              </span>
              {notification.status === "new" ? (
                marked.includes(notification.id) ? (<span> </span>):
                <span
                  className="text-xs text-gray-700 border border-primary w-fit cursor-pointer rounded-md px-1"
                  onClick={() => handleMarkAsRead(notification.id)}
                >
                  Mark as read
                </span>
              ) : (
                <span> </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
